import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FaPlus, FaUsers } from 'react-icons/fa'
import { getAllStaff } from '../../../store/actions/staff'
import { Button } from '../../../UI'
import StaffForm from './StaffForm'
import StaffListItem from './StaffListItem'
import StaffDetails from './StaffDetails'
import Container from './styles'

const Staff = () => {
  const dispatch = useDispatch()
  const staffData = useSelector((s) => s.StaffData || { data: [] })
  const staff = staffData.data || []
  const [showForm, setShowForm] = useState(false)
  const [showDetails, setShowDetails] = useState(false)
  const [selectedStaff, setSelectedStaff] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    dispatch(getAllStaff())
  }, [dispatch])

  const handleSearch = (e) => {
    const value = e.target.value
    setSearchTerm(value)
    dispatch(getAllStaff(1, 10, value))
  }

  const handleStaffClick = (staffMember) => {
    setSelectedStaff(staffMember)
    setShowDetails(true)
  }

  const openForm = () => {
    console.log('Opening staff form...')
    setShowForm(true)
  }

  return (
    <Container>
      <header>
        <div className="top--row">
          <h2>Staff Management</h2>
        </div>
        <div className="header--row">
          <div>
            <input 
              type="search" 
              placeholder="Search staff..." 
              className="search-input"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
          <Button className="add--btn" onClick={openForm}>
            <FaPlus className="icon" />
            <span>Add Staff</span>
          </Button>
        </div>
      </header>

      <div className="content--container">
        {staff.length === 0 ? (
          <div className="empty--container">
            <FaUsers style={{ fontSize: '4rem', color: 'rgba(255, 255, 255, 0.3)' }} />
            <h3>No Staff Members Yet</h3>
            <p className="instruction">
              Add staff members to give them access to your company dashboard
            </p>
            <Button className="add--btn" onClick={openForm}>
              <FaPlus className="icon" />
              Invite First Staff Member
            </Button>
          </div>
        ) : (
          <div className="staff--grid">
            {staff.map((staffMember) => (
              <div key={staffMember.id} onClick={() => handleStaffClick(staffMember)}>
                <StaffListItem staff={staffMember} />
              </div>
            ))}
          </div>
        )}
      </div>

      {showForm && <StaffForm show={showForm} handleClose={() => setShowForm(false)} />}
      {showDetails && (
        <StaffDetails 
          show={showDetails} 
          handleClose={() => {
            setShowDetails(false)
            setSelectedStaff(null)
          }} 
          staff={selectedStaff} 
        />
      )}
    </Container>
  )
}

export default Staff
